import { render, staticRenderFns } from "./WithdrawalsFilter.vue?vue&type=template&id=3a8ffc6f&scoped=true&"
import script from "./WithdrawalsFilter.vue?vue&type=script&lang=js&"
export * from "./WithdrawalsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ffc6f",
  null
  
)

export default component.exports